import React from 'react';

import { GOAL_VISIBILITY_OPTIONS } from 'constants/ProjectConstants';

import InputLabel from 'uiToolkitV1/InputLabel';
import { SelectV2 } from 'uiToolkitV1/SelectV2';

export const OKRVisibilityComponent = ({
  visibilityType = GOAL_VISIBILITY_OPTIONS[0].value,
  onChange,
  isReadOnly,
  renderControlItem,
}) => {
  const selectedVisibility = GOAL_VISIBILITY_OPTIONS.find(({ value }) => value === visibilityType);

  const handleOnChange = (newValue) => {
    if (newValue?.value !== visibilityType) onChange(newValue);
  };

  return (
    <SelectV2
      isReadOnly={isReadOnly}
      menuItems={GOAL_VISIBILITY_OPTIONS}
      selectedItem={selectedVisibility}
      onSelect={handleOnChange}
      renderControlItem={renderControlItem}
    />
  );
};

const OKRVisibility = ({ visibilityType, onChange, isReadOnly, renderControlItem }) => (
  <InputLabel labelText="Visibility">
    <OKRVisibilityComponent
      visibilityType={visibilityType}
      onChange={onChange}
      isReadOnly={isReadOnly}
      renderControlItem={renderControlItem}
    />
  </InputLabel>
);
export default OKRVisibility;
